import {Button, Center, Container, Group, Loader, Stack, Title} from "@mantine/core";
import {Link, useNavigate} from "@tanstack/react-router";
import {LibraryList, useDeleteLibraryEntry, useLibraryEntries} from "@/app/library";

export function LibraryPage() {
  const navigate = useNavigate();
  const entries = useLibraryEntries();
  const deleteMutation = useDeleteLibraryEntry();

  const handleDelete = async (uri: string) => {
    if (window.confirm("Are you sure you want to delete this entry?")) {
      await deleteMutation.mutateAsync(uri);
    }
  };

  return (
    <Container size="md" py="xl">
      <Stack gap="lg">
        <Group justify="space-between">
          <Title order={2}>My Library</Title>
          <Group>
            <Button component={Link} to="/library/new" variant="light">
              Batch Import
            </Button>
            <Button component={Link} to="/library/new-single" variant="filled">
              Add Entry
            </Button>
          </Group>
        </Group>

        {entries === undefined ? (
          <Center py="xl">
            <Loader size="lg" />
          </Center>
        ) : (
          <LibraryList
            entries={entries}
            onEdit={entry => {
              const rkey = entry.uri.split("/").pop();
              navigate({
                to: "/library/entry/$rkey",
                params: {rkey: rkey as string},
              });
            }}
            onDelete={handleDelete}
          />
        )}
      </Stack>
    </Container>
  );
}
